import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, Button, CircularProgress } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import SnackbarAlert from "../../../components/element/SnackbarAlert";
import "../CSS/AddFuelMeterDialog.css";

const SubmitFuelMeterReadingDialog = ({
  open,
  onClickSubmit,
  onClose,
  isLoading,
}) => {
  const [endReading, setEndReading] = useState(0.0);
  const [fuelWastage, setFuelWastage] = useState(0.0);
  const [fuelRecirculation, setFuelRecirculation] = useState(0.0);
  const [fuelTesting, setFuelTesting] = useState(0.0);
  const [showValidationError, setShowValidationError] = useState(false);

  useEffect(() => {
    setEndReading(0.0);
    setFuelWastage(0.0);
    setFuelRecirculation(0.0);
    setFuelTesting(0.0);
    setShowValidationError(false);
  }, [open]);

  const handleSubmit = () => {
    // Validate that only the end reading is greater than 0
    if (endReading <= 0) {
      setShowValidationError(true);
      return;
    }

    onClickSubmit(endReading, fuelWastage, fuelRecirculation, fuelTesting);
  };

  const handleCloseError = () => {
    setShowValidationError(false);
  };

  const isValidToSubmit = () => {
    return endReading > 0;
  };

  return (
    <>
      {showValidationError && (
        <SnackbarAlert type={"error"} onClose={handleCloseError}>
          Please enter a valid end reading before submitting
        </SnackbarAlert>
      )}
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          className: "add-fuel-meter-dialog-container",
        }}
      >
        <DialogContent>
          <CloseOutlined
            className="add-fuel-meter-dialog-close"
            onClick={onClose}
          />
          <div className="add-fuel-meter-dialog-content">
            <div className="add-fuel-meter-dialog-title">
              Add your Meter Reading
            </div>
            <div className="add-fuel-meter-input-container">
              <label>Fuel Meter End (gallons)*</label>
              <input
                name="add-fuel-end-reading"
                placeholder="Enter end reading"
                variant="outlined"
                type="number"
                min="0"
                value={endReading}
                onChange={(e) => {
                  setEndReading(e.target.value);
                  setShowValidationError(false);
                }}
              />
            </div>
            <div className="add-fuel-meter-input-container">
              <label>Fuel Wastage (gallons)</label>
              <input
                name="add-fuel-wastage"
                placeholder="Enter fuel wastage"
                variant="outlined"
                type="number"
                min="0"
                value={fuelWastage}
                onChange={(e) => {
                  setFuelWastage(e.target.value);
                  setShowValidationError(false);
                }}
              />
            </div>
            <div className="add-fuel-meter-input-container">
              <label>Fuel Recirculation (gallons)</label>
              <input
                name="add-fuel-recirculation"
                placeholder="Enter fuel recirculation"
                variant="outlined"
                type="number"
                min="0"
                value={fuelRecirculation}
                onChange={(e) => {
                  setFuelRecirculation(e.target.value);
                  setShowValidationError(false);
                }}
              />
            </div>
            <div className="add-fuel-meter-input-container">
              <label>Fuel Testing (gallons)</label>
              <input
                name="add-fuel-testing"
                placeholder="Enter fuel testing"
                variant="outlined"
                type="number"
                min="0"
                value={fuelTesting}
                onChange={(e) => {
                  setFuelTesting(e.target.value);
                  setShowValidationError(false);
                }}
              />
            </div>
            <Button
              variant="contained"
              onClick={!isLoading ? handleSubmit : null}
              endIcon={
                isLoading ? (
                  <CircularProgress size={30} color="inherit" />
                ) : null
              }
            >
              Submit
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SubmitFuelMeterReadingDialog;
